import { DigitalVaultPage } from 'components/cornerstone/digitalVault/DigitalVaultPage'
import { GetStaticProps } from 'next'
import { REVALIDATE_SECS } from 'utils/constants'
import { getContentfulImages, getContentfulVideoIds } from 'utils/contentful/getPageImages'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  return <DigitalVaultPage />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: {
      ...(await getIntlProps(
        ctx,
        ['digital_vault', 'dashboard', 'trusted_contact', 'device'],
        true
      )),
      ...(await getContentfulImages()),
      ...(await getContentfulVideoIds()),
    },
    revalidate: REVALIDATE_SECS,
  }
}
